(() => {
  const bind = () => document.querySelectorAll('media-gallery[data-sa-gallery]').forEach(gallery => {
    if (gallery.dataset.saBound) return;
    gallery.dataset.saBound = 'true';
    new ResizeObserver(() => gallery.style.setProperty('--sa-gallery-mid', `${gallery.querySelector('.product__media-item.is-active').getBoundingClientRect().height / 2}px`)).observe(gallery.querySelector('[id^="GalleryViewer"]'));
    const media = [...gallery.querySelectorAll('.product__media-item[data-media-id]')];
    const currentIndex = () => {
      const selected = gallery.querySelector('.thumbnail[aria-current="true"]')?.closest('[data-target]')?.dataset.target;
      return media.findIndex(item => item.dataset.mediaId === selected || (!selected && item.classList.contains('is-active')));
    };
    const move = direction => {
      const current = currentIndex();
      const next = media[(current + direction + media.length) % media.length];
      gallery.setActiveMedia(next.dataset.mediaId, false);
      gallery.querySelector('[data-sa-gallery-count]').textContent = `${media.indexOf(next) + 1} / ${media.length}`;
    };
    gallery.querySelectorAll('[data-sa-gallery-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.saGalleryStep))));
    gallery.querySelectorAll('.thumbnail').forEach(button => button.addEventListener('keydown', event => {
      if (!['ArrowUp', 'ArrowDown'].includes(event.key) || !matchMedia('(min-width: 750px)').matches) return;
      event.preventDefault();
      move(event.key === 'ArrowDown' ? 1 : -1);
      gallery.querySelector('.thumbnail[aria-current="true"]')?.focus({preventScroll:true});
    }));
    new MutationObserver(() => {
      const index = currentIndex();
      gallery.querySelector('[data-sa-gallery-count]').textContent = `${index + 1} / ${media.length}`;
    }).observe(gallery, {subtree:true, attributes:true, attributeFilter:['class','aria-current']});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
